var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","outlined":""},on:{"click":_vm.addressSearch}},[_vm._v("\n  郵便番号検索\n")])}
var staticRenderFns = []

export { render, staticRenderFns }